export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
};

declare global {
  interface Window {
    deferredInstallPrompt?: BeforeInstallPromptEvent;
  }
}

export function registerInstallPrompt() {
  if (typeof window === 'undefined') return;

  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    window.deferredInstallPrompt = event as BeforeInstallPromptEvent;
  });

  window.addEventListener('appinstalled', () => {
    window.deferredInstallPrompt = undefined;
  });
}

function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & {standalone?: boolean}).standalone === true
  );
}

function isIOSorIPadOS() {
  const ua = navigator.userAgent;

  return (
    /iPhone|iPad|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  );
}

function isSafari() {
  const ua = navigator.userAgent;

  return (
    /Safari/i.test(ua) &&
    !/Chrome|CriOS|Edg|EdgiOS|OPR|Firefox|FxiOS/i.test(ua)
  );
}

function isFirefox() {
  return /Firefox|FxiOS/i.test(navigator.userAgent);
}

function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

function isMac() {
  return /Macintosh|Mac OS X/i.test(navigator.userAgent);
}

export async function installSite() {
  if (isStandalone()) {
    alert('الموقع مثبت بالفعل على هذا الجهاز.');
    return;
  }

  const deferredPrompt = window.deferredInstallPrompt;

  if (deferredPrompt) {
    await deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    window.deferredInstallPrompt = undefined;
    return;
  }

  if (isIOSorIPadOS()) {
    alert(
      'لتثبيت الموقع على iPhone أو iPad:\n\n' +
        '1. افتح الموقع في Safari.\n' +
        '2. اضغط زر المشاركة Share.\n' +
        '3. اختر Add to Home Screen.\n' +
        '4. اضغط Add.'
    );
    return;
  }

  if (isMac() && isSafari()) {
    alert(
      'لتثبيت الموقع على Mac عبر Safari:\n\n' +
        'من القائمة اختر File ثم Add to Dock.'
    );
    return;
  }

  if (isAndroid()) {
    alert(
      'لتثبيت الموقع على Android:\n\n' +
        'افتح قائمة المتصفح ثم اختر Install app أو Add to Home Screen.'
    );
    return;
  }

  if (isFirefox()) {
    alert(
      'Firefox على الكمبيوتر لا يوفر زر تثبيت PWA مباشر مثل Chrome.\n\n' +
        'يمكنك إنشاء اختصار للموقع من قائمة المتصفح.'
    );
    return;
  }

  alert(
    'للتثبيت، افتح قائمة المتصفح واختر Install app أو Add to Home Screen.'
  );
}
